import React from 'react';
import MultiselectDropDown from 'multiselect-react-dropdown';

import { SelectOption } from '../../../utils/models';

import classNames from './style.module.scss';

interface MultiSelectProps {
	options: SelectOption[];
	selectedValues: SelectOption[];
	onSearch: (value: string) => void;
	onSelect: (selectedList: any[], selectedItem: SelectOption) => void;
	onRemove: (selectedList: any[], removedItem: SelectOption) => void;
	showCheckbox: boolean;
	loading: boolean;
	selectionLimit?: number;
	singleSelect: boolean;
	label: string;
	placeholder: string;
	error?: string;
}

const MultiSelect: React.FC<MultiSelectProps> = (props) => {
	return (
		<div className={classNames['form-input-group']}>
			{props.label && (
				<div className={classNames['form-input-group-label']}>
					{props.label}:
				</div>
			)}

			<MultiselectDropDown
				options={props.options}
				onSearch={props.onSearch}
				loading={props.loading}
				style={style}
				showCheckbox={props.showCheckbox}
				singleSelect={props.singleSelect}
				selectedValues={props.selectedValues}
				onSelect={props.onSelect}
				onRemove={props.onRemove}
				className={classNames['form-input-group-field']}
				placeholder={props.placeholder}
				selectionLimit={props.selectionLimit}
				showArrow
				displayValue="name" // Property name to display in the dropdown options
			/>

			{props.error && <div className="error">{props.error}</div>}
		</div>
	);
};

MultiSelect.defaultProps = {
	selectionLimit: -1,
};

const style = {
	searchBox: {
		// To change search box element look
	},
	inputField: {
		// To change input field position or margin
	},
	chips: {
		// To change css chips(Selected options)
		backgroundColor: '#172b4d',
	},
	optionContainer: {
		// To change css for option container
		border: '1px solid #dfe1e6',
	},
	option: {
		// To change css for dropdown options
		color: '#172b4d',
	},
	//   groupHeading: { // To chanage group heading style
	//     ....
	//   }
};

export default MultiSelect;
